import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-warning",
  "use": "app-icon-warning-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"app-icon-warning\"><path d=\"M46.6 40L36.5 22.2 26.4 4.4c-1-1.8-3.6-1.8-4.6 0L11.6 22.2 1.5 40c-1 1.8.3 4.1 2.3 4.1h40.4c2.2-.1 3.5-2.3 2.4-4.1zM23.2 16.8h1.6c.9 0 1.7.7 1.7 1.6l-.8 11.4c0 .9-.7 1.6-1.7 1.6-.9 0-1.7-.7-1.7-1.6l-.8-11.4c.1-.9.8-1.6 1.7-1.6zm.9 23.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.2 2.5-2.5 2.5z\" fill=\"#f83\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol